import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from '@/pages/HomePage';
import TeamsPage from '@/pages/TeamsPage';
import LegendPage from '@/pages/LegendPage';
import PlayerDetailPage from '@/pages/PlayerDetailPage';
import TeamDetailPage from '@/pages/TeamDetailPage';
import AboutPage from '@/pages/AboutPage';
import UpdatesPage from '@/pages/UpdatesPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/teams' element={<TeamsPage />} />
        <Route path='/legends' element={<LegendPage />} />
        <Route path='/about' element={<AboutPage />} />
        <Route path='/updates' element={<UpdatesPage />} />
        <Route path='/player/:id' element={<PlayerDetailPage />} />
        <Route path='/team/:id' element={<TeamDetailPage />} />
      </Routes>
    </Router>
  );
}

export default App;
